export default {
  // Bežné slová
  enter: "Vstúpiť",
  next: "Ďalej",
  previous: "Predchádzajúce",
  finish: "Dokončiť",
  returnToWebsite: "Vrátiť sa na webovú stránku",
  complete: "Dokončiť",
  submit: "Odoslať",
  cancel: "Zrušiť",
  yes: "Áno",
  no: "Nie",
  skip: "Preskočiť",
  close: "Zavrieť",
  discard: "Zahodiť",
  save: "Uložiť",
  "thank-you": "Ďakujeme",
  select: "Vybrať",
  hi: "Ahoj",
  hello: "Dobrý deň",
  link: "Odkaz",
  back: "Späť",
  view: "Zobraziť",
  continue: "Pokračovať",
  of: "z",

  // Hlavný prieskum klienta
  "client-survey-main-thanks-note":
    "Ďakujeme, že ste si našli čas, vaša spätná väzba formuje našu ponuku <br /> do budúcnosti.",
  "client-survey-how-likely-recommend":
    "Aká je pravdepodobnosť, že by ste nás odporučili ostatným?",
  "client-survey-how-likely-note":
    "Na škále 0 - 10, kde 0 znamená vôbec nie a 10 znamená veľmi pravdepodobne.",
  "client-survey-how-likely-recommend-question":
    "Čo je tá jedna vec, ktorú by sme mohli urobiť, aby sme vás viac motivovali nás odporučiť?",
  "step-of": "Krok {step} z {total}",
  step: "Krok {step}",
  "client-survey-how-satisfied-with-service": "Ako ste spokojní so službou",
  "client-survey-how-satisfied-with-service-question":
    "Čo je tá jedna vec, ktorú by sme mohli urobiť pre zlepšenie?",
  "client-survey-how-satisfied-with-food":
    "Ako ste spokojní s jedlom, ktoré od nás dostávate?",
  "client-survey-how-satisfied-with-food-question":
    "Čo je tá jedna vec, ktorú by sme mohli urobiť pre zlepšenie?",
  "client-survey-what-is-the-best-thing-about-working-with-us":
    "Čo je najlepšie na spolupráci s nami? Prosím vyberte všetko, čo je dôležité.",
  "management-team": "Manažérsky tím",
  "the-front-line-operations-team": "Tím prevádzky v prvej línii",
  "food-offering": "Ponuka jedla",
  innovation: "Inovácie",
  communication: "Komunikácia",
  "flexibility-and-responsiveness": "Flexibilita a reakcia",
  billing: "Fakturácia",
  "health-and-hygiene-standards": "Zdravotné a hygienické štandardy",
  "if-other-please-specify": "Ak iné, prosím špecifikujte...",
  "based-on-the-service-we-provide-where-can-we-improve-the-most-please-select-all-that-matters":
    "Na základe služby, ktorú poskytujeme, kde sa môžeme najviac zlepšiť? Prosím vyberte všetko, čo je dôležité.",
  "please-can-we-have-some-more-detail": "Môžeme dostať viac podrobností?",
  "to-help-us-understand-your-csr-priorities-please-order-in-rank-of-importance-the-following":
    "Aby sme pochopili vaše CSR priority, prosím zoraďte podľa dôležitosti nasledovné:",
  "sustainable-ingredients": "Udržateľné ingrediencie",
  "food-waste": "Plytvania jedlom",
  "local-sourcing": "Miestne zásobovanie",
  "people-and-communities": "Ľudia &amp; komunity",
  "energy-reduction": "Zníženie energie",
  "working-with-local-communities": "Práca s miestnymi komunitami",
  "environmental-choices": "Environmentálne voľby",
  "meat-free": "Bez mäsa",
  "less-plastic": "Menej plastov",
  "would-you-like-to-be-contacted-about-your-feedback":
    "Chceli by ste byť kontaktovaní ohľadom vašej spätnej väzby? Ak áno, prosím zanechajte vaše kontaktné informácie nižšie",
  "full-name": "Celé meno",
  "email-address": "E-mailová adresa",
  "phone-number": "Telefónne číslo",
  feedback: "Spätná väzba",
  "view-our-privacy-policy": "Zobraziť naše zásady ochrany súkromia",
  "thank-you-for-taking-time-to-complete-the-survey":
    "Ďakujeme, že ste si našli čas na dokončenie prieskumu!",

  // 404 Nenájdené
  "404-not-found": "404 Nenájdené",

  // Zásady ochrany súkromia
  "privacy-policy": "Zásady ochrany súkromia",

  // Spätná väzba hodnotenia zamestnancov na webe - Krok 1
  "employee-web-rating-feedback-step-1-positive":
    "Teší nás, že sa cítite pozitívne, radi by sme vedeli prečo?",
  "employee-web-rating-feedback-step-1-negative":
    "Ľutujeme, že sa necítite najlepšie, môžete nám povedať prečo?",

  // Spätná väzba hodnotenia zamestnancov na webe - Krok 2
  "employee-web-rating-feedback-step-2-heading":
    "Je niečo ďalšie, čo by ste sa s nami chceli dnes podeliť?",
  "employee-web-rating-feedback-step-2-information":
    "Máte nejaké komentáre alebo spätnú väzbu o vašej dnešnej skúsenosti s nami?",
  "employee-web-rating-feedback-step-2-placeholder":
    "Podeľte sa s nami o vašu dnešnú skúsenosť...",

  // Spätná väzba hodnotenia zamestnancov na webe - Krok 3
  "employee-web-rating-feedback-step-3-heading":
    "Chceli by ste niekomu vyjadriť uznanie?",
  "no-employees-found": "Žiadni zamestnanci nenájdení",

  // Domovská stránka hodnotenia zamestnancov na webe
  "choose-location": "Vybrať umiestnenie",
  "search-location": "Hľadať umiestnenie",
  "feedback-anonymous": "Chcete zachovať vašu spätnú väzbu anonymnú?",
  "feedback-feeling-today": "Ako sa dnes cítite?",

  // Stránka s poďakovaním za hodnotenie zamestnancov na webe
  "thank-you-for-your-feedback": "Ďakujeme za vašu spätnú väzbu!",
  "back-to-home": "Späť domov",
  page: "Stránka",

  // Upozornenie na jednorazovú spätnú väzbu
  "feedback-once-alert": "Spätná väzba už bola poskytnutá z tejto URL.",

  // Audit zákazníka na fronte
  "please-answer-above-question": "Prosím odpovedzte na vyššie uvedenú otázku.",
  "add-comments": "Pridať komentáre",
  "enter-answer": "Zadať odpoveď",
  "add-upload-files": "Pridať nahrané súbory",

  // Otázky Alphega
  "did-you-buy-medicine-in-the-pharmacy-today":
    "Kúpili ste si dnes lieky v lekárni?",
  "were-you-asked-any-of-the-following":
    "Boli ste sa opýtaní na niečo z nasledovného:",
  "who-is-the-medicine-for": "Pre koho sú lieky?",
  "what-are-your-symptoms": "Aké sú vaše príznaky?",
  "how-long-you-had-the-symptoms": "Ako dlho máte príznaky?",
  "what-action-you-have-already-taken": "Aké opatrenia ste už prijali?",
  "are-you-taking-any-other-medication": "Užívate nejaké iné lieky?",

  // Alphega - Other Companies Questions
  "did-you-wait-more-than-10-minutes-to-be-served":
    "Čakali ste viac ako 10 minút predtým, než ste boli obsluhovaní?",
  "were-the-products-you-wanted-in-stock":
    "Boli produkty, ktoré ste chceli v sklade?",
  "were-the-staff-friendly-and-helpful":
    "Boli pracovníci priateľskí a pomocní?",
  "did-you-receive-any-advice-about-your-medicines":
    "Získali ste nejaké rady o vašich liekoch?",

  // Mobilná domovská stránka
  "how-was-your-experience-with-us-today":
    "Aká bola vaša dnešná skúsenosť s nami?",

  // Mobilná stránka s poďakovaním
  "thank-you-for-your-time-and-your-answers":
    "Ďakujeme za váš čas a vaše odpovede.",
  "would-also-like-to-rate-us-on-google":
    "Chceli by ste nás tiež ohodnotiť na Google?",
  "rate-us-now": "Ohodnotiť nás teraz",

  // Negatívna odpoveď chatu
  "select-skill": "Vybrať zručnosť",
  "none-selected": "Nič nevybrané",
  "can-we-get-in-touch-with-you-about-your-experience-today":
    "Môžeme sa s vami spojiť ohľadom vašej dnešnej skúsenosti?",
  "write-here": "Napíšte sem...",
  "please-can-we-get-your-name": "Môžeme dostať vaše meno?",
  "please-enter-your-email": "Prosím zadajte váš e-mail:",
  "enter-your-phone-number": "Zadajte vaše telefónne číslo:",
  "please-tell-us-a-bit-more-about-your-experience":
    "Prosím povedzte nám trochu viac o vašej skúsenosti:",
  "you-have-already-submitted-rating": "Už ste odoslali hodnotenie",
  "sorry-to-hear-you-didn-t-have-the-best-experience-today-with-us-please-could-you-highlight-what-went-wrong":
    "Ľutujeme, že ste s nami dnes nemali najlepšiu skúsenosť, mohli by ste zdôrazniť, čo sa pokazilo?",

  // Pozitívna odpoveď chatu
  "select-employee": "Vybrať zamestnanca",
  "we-d-love-to-know-who-looked-after-you-today":
    "Radi by sme vedeli, kto sa o vás dnes staral?",
  "what-stood-out-to-you-today": "Čo vám dnes vyniklo?",
  "did-we-provide-exceptional-service-today":
    "Poskytli sme dnes výnimočnú službu?",
  "do-you-have-any-comments-or-feedback-about-your-experience-with-us-today":
    "Máte nejaké komentáre alebo spätnú väzbu o vašej dnešnej skúsenosti s nami?",

  // Riaditeľ Client Connect
  "message-from-leadership": "Správa od vedenia",
  "message-from-leadership-text":
    "Neustále hľadám spôsoby, ako zlepšiť našu ponuku pre našu klientelu. Sú aspekty, ktoré by sme mohli podľa vášho názoru zlepšiť?",
  "client-connect-director-another-note":
    "Na druhej strane, ak je konkrétna téma, ktorú by ste chceli, aby náš tím riešil, neváhajte sa podeliť. Nie som tu len na počúvanie, ale na zapojenie sa a konanie na základe vašich obáv alebo nápadov.",
  "your-message-here": "Vaša správa tu",
  "visit-information": "Informácie o návšteve",
  "visit-time-out": "Čas odchodu z návštevy",
  "contact-information": "Kontaktné informácie",
  "client-connect-director-contact-information-text":
    "Pre poskytnutie lepšej pomoci vás láskavo žiadame o vaše údaje, vrátane vášho mena, e-mailovej adresy a kontaktného čísla. Tieto informácie nám umožnia rýchlo reagovať a kontaktovať vás.",
  name: "Meno",
  "enter-your-name": "Zadajte vaše meno",
  email: "E-mail",
  "enter-your-email": "Zadajte váš e-mail",
  "contact-number": "Kontaktné číslo",
  "please-enter-your-name": "Prosím zadajte vaše meno",
  "please-enter-your-email-or-phone-number":
    "Prosím zadajte váš e-mail alebo telefónne číslo",
  "invalid-email-address": "Neplatná e-mailová adresa",
  "invalid-phone-number-format":
    "Neplatné telefónne číslo pre vybranú krajinu.",
  "no-match-found": "Žiadna zhoda",
  "phone-number-must-be-digits-for-country":
    "Telefónne číslo musí mať {count} číslic pre vybranú krajinu ({current}/{count}).",
  "phone-number-must-be-digits-range-for-country":
    "Telefónne číslo musí mať {min}–{max} číslic pre vybranú krajinu ({current}/{max}).",
  "please-select-time": "Prosím vyberte čas",
  "you-must-provide-at-least-one-answer-before-submitting-the-survey":
    "Musíte poskytnúť aspoň jednu odpoveď pred odoslaním prieskumu.",

  // Mobilné otázky prieskumu CheckBoxType
  comment: "Komentár",
  "comment-is-required": "Komentár je povinný!",
  "minimum-selection-is": "Minimálny výber je {min_options}",
  "maximum-selection-is": "Maximálny výber je {max_options}",
  "this-question-is-required": "Táto otázka je povinná!",
  "please-fill-all-required-grid-rows":
    "Prosím, vyplňte všetky povinné riadky mriežky!",
  "please-fill-mandatory-fields-to-continue":
    "Prosím vyplňte povinné polia pre pokračovanie",

  // Mobilné otázky prieskumu CommentsAndImage
  "please-select-valid-image-files": "Prosím vyberte platné obrázkové súbory.",

  // Mobilné otázky prieskumu EmployeeType
  loading: "Načítava sa",
  "getting-employee": "Získavam zamestnanca...",

  // Mobilné otázky prieskumu FileUploadType
  "please-select-valid-image-or-video-files":
    "Prosím vyberte platné obrázkové alebo video súbory.",
  "please-select-a-valid-file":
    "Prosím vyberte platný súbor (obrázok, video, PDF alebo Word).",

  // Mobilné otázky prieskumu NumberType
  "please-enter-a-number-without-any-decimal-points":
    "Prosím zadajte číslo bez desatinných miest.",
  "please-enter-a-number-less-than-or-equal-to":
    "Prosím zadajte číslo menšie alebo rovné {max_number_value}.",

  // Mobilné otázky prieskumu SignatureType
  "please-complete-your-signature": "Prosím dokončite váš podpis.",

  // Mobilné otázky prieskumu TextType
  "please-enter-valid-email-address": "Prosím zadajte platnú e-mailovú adresu.",
  "phone-number-should-be-10-digit": "Telefónne číslo by malo mať 10 číslic.",
  "please-enter-at-least-characters":
    "Prosím zadajte aspoň {minimum_character} znakov.",
  "select-date": "Vybrať dátum",
  "select-time": "Vybrať čas",
  "client-connect-date-picker-aria": "Dátum: {value}. Otvorte výber dátumu",
  "client-connect-time-picker-aria": "Čas: {value}. Otvorte výber času",
  "select-country": "Vybrať krajinu",

  // Stránka správy
  "click-the-link-to-see-how": "Kliknite na odkaz, aby ste videli ako.",
  "adding-your-teams-to-the-ServeFirst-reporting-platform":
    "Že pridaním vašich tímov na reportovaciu platformu ServeFirst sa môžu tiež prihlásiť a vidieť svoj výkon, taktiež; máte možnosť spravovať váš tím a pristupovať k dodatočným správam na pochopenie vášho celkového výkonu -",
  "did-you-know": "Vedeli ste..",
  count: "počet",
  average: "priemer",
  focus: "zameranie",
  performance: "Výkon",
  "you-can-create-bespoke-action-plans":
    "Môžete vytvoriť prispôsobené akčné plány, ktoré sa filtrujú priamo sem, ak sú vytvorené vo vašom ServeFirst účte, tu môžete okamžite vytvárať akcie, časové harmonogramy a vlastníkov pri sledovaní výkonu. -",
  "no-of-times-raised": "Počet krát vznesené",
  action: "Akcia",
  "attribute-name": "Názov atribútu",
  "action-plan": "Akčný plán",
  "that-by-adding-your-teams-to-the-ServeFirst-reporting-platform":
    "Že pridaním vašich tímov na reportovaciu platformu ServeFirst sa môžu tiež prihlásiť a vidieť svoj výkon, taktiež; máte možnosť spravovať váš tím a pristupovať k dodatočným správam na pochopenie vášho celkového výkonu -",
  result: "Výsledok",
  category: "Kategória",
  "your-location-vs-all-location": "Vaše umiestnenie vs. všetky umiestnenia",
  "net-promoter-score": "Net Promoter Score",
  "responses-breakdown": "Rozdelenie odpovedí",
  "trended-net-promoter-score": "Trendový Net Promoter Score",
  "trended-results": "Trendové výsledky",
  "net-promoter-score-info":
    "Net Promoter Score je založené na % podporovateľov (Skóre 5/5) - % kritikov (Skóre 1, 2 alebo 3), viac o Net Promoter Score sa môžete dozvedieť kliknutím na nasledovné",
  "customer-feedback": "Spätná väzba zákazníka",
  logan: "Logan",
  "top-performer": "Najlepší výkonný",
  "rank-in-the-country": "Poradie v krajine",
  "ytd-score": "YTD skóre",
  "score-during-period": "Skóre počas obdobia",
  "0-from-last-month": "0 z minulého mesiaca",
  "total-responses-for-july-2021": "Celkové odpovede za júl 2021",
  promoter: "Podporovateľ",
  "from-04-sep-2021-to-06-sep-2021": "Od 04 sep 2021 do 06 sep 2021",
  "the-focus-currently-is-on": "Zameranie je momentálne na",
  "1-number-of-customers-have-stated-this-as-an-opportunity":
    "1 počet zákazníkov uviedol toto ako príležitosť.",
  "focus-for-the-month": "Zameranie na mesiac",
  "download-pdf": "Stiahnuť pdf",

  // Nová správa stránky správy
  "total-responses": "Celkové odpovede",
  duration: "Trvanie",
  "customers-have-stated-this-as-an-opportunity":
    "zákazníci uviedli toto ako príležitosť",
  "error-fetching-params": "Chyba pri načítavaní parametrov!",
  "previous-days-was": "Predchádzajúcich {days} dní bolo {score}",

  // Spoločná LgCard stránky správy
  "raised-on": "# Vznesené dňa",
  results: "Výsledky",

  // Komponenty stránky správy AiSuggestions
  "analyzing-data-please-wait": "Analyzujem údaje, prosím čakajte...",

  // Komponenty stránky správy CustomerFeedBack
  "view-report": "Zobraziť správu",
  "received-on": "Prijaté dňa",

  // Komponenty stránky správy ResponseBreakdown
  detractors: "Kritici",
  nps: "NPS",

  // Komponenty stránky správy TrendResults
  "trend-results": "Trendové výsledky",

  // Pomocníci prieskumu Utils
  "failed-to-fetch-the-pdf-file": "Nepodarilo sa načítať PDF súbor",
  "error-generating-pdf-thumbnail": "Chyba pri generovaní náhľadu PDF",
  "error-in-thumbnail-generation-function":
    "Chyba vo funkcii generovania náhľadu",
  "failed-to-generate-pdf-thumbnail": "Nepodarilo sa vygenerovať náhľad PDF",

  // Stránky prieskumu Audition
  "select-audit": "Vybrať audit",

  // Stránky prieskumu ClientConnect
  "select-atleast-min-options": "Vyberte aspoň {minOptions} možností",
  "select-max-options": "Maximálne {maxOptions} možností povolených!",
  "error-saving-your-response": "Chyba pri ukladaní vašej odpovede!",
  "failed-to-load-the-file": "Nepodarilo sa načítať súbor!",
  "open-link": "Otvoriť odkaz",
  download: "Stiahnuť",
  details: "Podrobnosti",
  title: "Názov",
  description: "Popis",
  "general-info": "Všeobecné informácie",
  type: "Typ",
  size: "Veľkosť",
  "uploaded-by": "Nahrané od",

  // Stránky prieskumu ClientConnect Intro
  "thank-you-for-your-time": "Ďakujeme za váš čas!",

  // Stránky prieskumu ClientConnect Content
  "review-content": "Preskúmať obsah",

  // Stránky prieskumu ClientConnect Survey
  "please-give-us-your-feedback": "Prosím poskytnite nám vašu spätnú väzbu",
  "enter-your-response": "Zadajte vašu odpoveď",

  // Client Connect v2 (accordion UI)
  "client-connect-preview-hey": "Dobrý deň, {name}",
  "client-connect-preview-sent-from": "Odoslané od {sender} - {date}",
  "client-connect-preview-step-of": "Krok {current} z {total}",
  "client-connect-preview-getting-started": "Začíname",
  "client-connect-preview-getting-started-desc":
    "Pozrite si prehľadové materiály pripravené pre vás.",
  "client-connect-preview-share-feedback": "Zdieľajte spätnú väzbu",
  "client-connect-preview-share-feedback-desc":
    "Váš názor nám pomáha vytvoriť lepší zážitok pre vás.",
  "client-connect-preview-talk-leadership": "Rozhovor s vedením",
  "client-connect-preview-talk-leadership-desc":
    "Prečítajte si správu od vedenia a uložte svoju odpoveď.",
  "client-connect-preview-reviewed-these": "Prezrel(a) som si tieto",
  "client-connect-preview-send-feedback": "Odoslať spätnú väzbu",
  "client-connect-preview-finish-submit": "Dokončiť a odoslať",
  "client-connect-preview-save-finish": "Dokončiť a odoslať",
  "client-connect-preview-your-reply": "Vaša odpoveď",
  "client-connect-preview-saved": "Uložené",
  "client-connect-preview-edit": "Upraviť",
  "client-connect-preview-pop-out": "Otvoriť v okne",
  "client-connect-preview-open": "Otvoriť",
  "client-connect-preview-view": "Zobraziť",
  "client-connect-preview-welcome": "Vitajte",
  "client-connect-preview-feedback": "Spätná väzba",
  "client-connect-preview-save-message": "Odoslať správu",
  "client-connect-preview-message-footer":
    "Vaša správa ide priamo tímu vedenia.",
  "client-connect-preview-leadership-placeholder": "Zadajte svoju správu...",
  "client-connect-preview-thank-you": "Ďakujeme",
  "client-connect-preview-thank-you-body":
    "Dokončili ste Client Connect. Vaše odpovede v prieskume a správa boli odoslané tímu — čoskoro vás budú kontaktovať.",
  "client-connect-thank-you-message":
    "Ďakujeme za váš čas. Vaša spätná väzba naozaj niečo znamená.",
  "client-connect-preview-review-answers": "Skontrolovať moje odpovede",
  "client-connect-preview-back-dashboard": "Späť na dashboard",
  "client-connect-preview-already-submitted":
    "Vaša spätná väzba bola prijatá. Ďakujeme! Neváhajte preskúmať materiály vyššie.",
  "enter-email-address": "Zadajte emailovú adresu",
  "enter-phone-no": "Zadajte telefónne číslo",
  "product-type": "Typ produktu",
  "enter-number": "Zadajte číslo",
  aspect: "Aspekt",

  // Stránky prieskumu ClientConnect Director
  "i-am-constantly-seeking-ways-to-better-our-offerings-for-our-clientele":
    "Neustále hľadám spôsoby, ako zlepšiť našu ponuku pre našu klientelu. Sú aspekty, ktoré by sme mohli podľa vášho názoru zlepšiť?",
  "on-another-note-if-there-s-a-specific-topic-you-d-like-our-team-to-address-don-t-hesitate-to-share":
    "Na druhej strane, ak je konkrétna téma, ktorú by ste chceli, aby náš tím riešil, neváhajte sa podeliť. Nie som tu len na počúvanie, ale na zapojenie sa a konanie na základe vašich obáv alebo nápadov.",
  "to-provide-enhanced-assistance-we-kindly-ask-for-your-details-including-your-name-email-address-and-contact-number":
    "Pre poskytnutie lepšej pomoci vás láskavo žiadame o vaše údaje, vrátane vášho mena, e-mailovej adresy a kontaktného čísla. Tieto informácie nám umožnia rýchlo reagovať a kontaktovať vás.",

  // Stránky prieskumu Location
  "select-the-location-you-visited":
    "Vyberte umiestnenie, ktoré ste navštívili",
  locations: "Umiestnenia",
  "is-this-your-current-location": "Je toto vaše súčasné umiestnenie?",
  "nearest-location": "Najbližšie umiestnenie",
  "loading-data": "Načítavam údaje...",
  "please-wait": "Prosím čakajte!",

  // Stránky prieskumu Location Area
  "location-area": "Oblasť umiestnenia",
  "select-location-area": "Vybrať oblasť umiestnenia",

  // Stránky prieskumu Login
  "please-enter-your-password": "Prosím zadajte vaše heslo",
  "value-must-be-longer-than-3-characters":
    "Hodnota musí byť dlhšia ako 3 znaky",
  "please-enter-your-email-address": "Prosím zadajte vašu e-mailovú adresu",
  password: "Heslo",
  "internal-server-error": "Vnútorná chyba servera !",
  "sign-in": "Prihlásiť sa",

  // Stránky prieskumu SameDaySurvey
  "you-have-already-performed-this-survey": "Tento prieskum ste už vykonali !",
  "csat-link-invalid": "Tento odkaz na prieskum už nie je platný.",

  // Stránky prieskumu SurveyThankYou
  "your-feedback-has-been-submitted":
    "Vaša spätná väzba bola odoslaná. Vaše číslo tiketu je #",
  "a-member-of-the-team-will-be-in-touch-shortly":
    "Člen tímu sa s vami čoskoro spojí.",
  "would-you-also-like-to-rate-us-on-google":
    "Chceli by ste nás tiež ohodnotiť na Google?",
  "to-review-our-terms-and-conditions-please-click":
    "Pre preskúmanie našich podmienok použitia, prosím kliknite",
  here: "Tu",
  "ticket-number-copied-to-clipboard": "Číslo tiketu skopírované do schránky",

  // Stránky prieskumu Welcome
  "visit-date": "Dátum návštevy",
  "visit-time-in": "Čas príchodu na návštevu",
  "please-select-date": "Prosím vyberte dátum",
  "guest-info": "Informácie o hosťovi",
  "please-select-user": "Prosím vyberte používateľa",
  "get-started": "Začať",

  // Stránky prieskumu InventoryType
  "enter-value": "Zadať hodnotu",
  "getting-product-list": "Získavam zoznam produktov...",

  // Stránky prieskumu NotesAndImage
  "upload-file": "Nahrať súbor",

  // Stránky prieskumu NumberType
  "enter-digit": "Zadať číslicu",

  // Stránky prieskumu TextArea
  "enter-your-comment": "Zadajte váš komentár",

  // Stránky prieskumu Upload
  "file-size-should-be-less-than-10-mb":
    "Veľkosť súboru by mala byť menšia ako 10 MB",
  "drag-you-files-here-file-size-less-than-10-mb-or":
    "Pretiahnite vaše súbory sem, veľkosť súboru menšia ako 10 MB alebo",
  "upload-or-drag-and-drop-your-files-here":
    "Nahrať alebo pretiahnuť a pustiť súbory sem",
  "browse-files": "Prehliadať súbory",

  // Stránky prieskumu Questions
  "next-question": "Ďalšia otázka",
  "save-and-exit": "Uložiť a ukončiť",
  "failed-to-save-and-exit":
    "Nepodarilo sa uložiť váš pokrok. Skúste to znova.",
  "progress-saved-you-may-close-this-tab":
    "Váš pokrok bol uložený. Teraz môžete zavrieť túto kartu prehliadača.",
  "please-enter-at-least": "Prosím zadajte aspoň {min} znakov.",
  "contact-no": "Kontaktné číslo",
  "please-select-location": "Prosím vyberte umiestnenie!",
  "please-select-survey": "Prosím vyberte prieskum!",
  "please-enter-your-email-address-or-phone-number":
    "Prosím zadajte vašu e-mailovú adresu alebo telefónne číslo.",

  // Utils CompressFiles
  "compression-error": "Chyba kompresie:",

  // Web Rating FrontLogin
  "enter-location-id": "Zadajte ID umiestnenia",
  "invalid-location-id": "Neplatné ID umiestnenia",
  "location-id-required": "ID umiestnenia je povinné",

  // Web Rating Index
  "please-tell-us-how-your-experience-was-today":
    "Prosím povedzte nám, aká bola vaša dnešná skúsenosť.",

  // Web Rating Negativefeedback
  "sorry-to-hear-you-didn-t-have-the-best-experience-today-with-us-please-could-you-highlight-what-went-wrong":
    "Ľutujeme, že ste s nami dnes nemali najlepšiu skúsenosť, mohli by ste zdôrazniť, čo sa pokazilo?",
  "enter-valid-email-address": "Zadajte platnú e-mailovú adresu.",
  "can-we-get-in-touch-with-you": "Môžeme sa s vami spojiť?",

  // Web Rating Positivefeedback
  "enter-your-telephone-number": "Zadajte vaše telefónne číslo",
  "write-your-feedback": "Napíšte vašu spätnú väzbu",

  // Web Rating Positivefeedback2
  "what-made-the-employee-name-stand-out-to-you":
    "Čo spôsobilo, že {employeeName} vám vynikol?",
  team: "Tím",

  // Web Rating PositivefeedbackForm
  "please-go-to-previous-step-and-select-employee-without-employee-selection-not-able-to-submit-feedback-form":
    "Prosím prejdite na predchádzajúci krok a vyberte zamestnanca, bez výberu zamestnanca nie je možné odoslať formulár spätnej väzby",
  "share-us-your-experience-with-us-today":
    "Podeľte sa s nami o vašu dnešnú skúsenosť...",
  "did-employee-name-provide-exceptional-service":
    "Poskytol {employeeName} výnimočnú službu?",
  "did-employee-name-stand-out-for-delivering-exceptional-service":
    "Vynikol {employeeName} poskytovaním výnimočnej služby?",

  // Web Rating New apiHelpers loginHelpers
  "please-enter-user-name": "Prosím zadajte používateľské meno",
  "please-enter-password": "Prosím zadajte heslo",

  // Web Rating New RatingLocations
  search: "Hľadať",
  "select-loction-to-ratings": "Vyberte umiestnenie na hodnotenie",
  location: "Umiestnenie",
  "is-this-your-location": "Je toto vaše umiestnenie?",
  "fetch-details-failed": "Načítanie podrobností zlyhalo",

  // Web Rating New PositiveJourny EmployeDetail
  "click-as-many-as-you-want": "Kliknite na toľko, koľko chcete",
  "what-made-employee-name-stand-out-to-you":
    "Čo spôsobilo, že {employeeName} vám vynikol?",
  "what-made-the-team-stand-out-to-you": "Čo spôsobilo, že tím vám vynikol?",

  // Web Rating New PositiveJourny EmployeService
  "did-we-stand-out-for-delivering-exceptional-service":
    "Vynikli sme poskytovaním výnimočnej služby?",

  // Web Rating New NegativeJourny EmployePersonalDetail
  "leave-an-email-or-phone-number-if-you-want-us-to-get-in-touch-otherwise-just-leave-it-blank-then-press-next":
    "Zanechajte e-mail alebo telefónne číslo, ak chcete, aby sme sa s vami spojili, inak to nechajte prázdne a stlačte ďalej",
  "anything-else-you-d-like-to-share":
    "Niečo ďalšie, čo by ste sa chceli podeliť?",
  "enter-valid-email": "Zadajte platný e-mail",
  message: "Správa",
  "by-signing-up-the-form-you-agree-to-our-terms-and-privacy":
    "Registráciou formulára súhlasíte s našimi podmienkami a ochranou súkromia.",

  // Web Rating New FrontWebLogin
  login: "Prihlásiť sa",
  username: "Používateľské meno",

  // Web Rating New FrontRating
  "press-the-facial-expression-that-best-represents-how-you-feel-about-your-experience":
    "Stlačte výraz tváre, ktorý najlepšie reprezentuje, ako sa cítite ohľadom vašej skúsenosti.",
  "getting-employee-list": "Získavam zoznam zamestnancov",
  "getting-skill-data": "Získavam údaje o zručnostiach",
  "getting-screen-saver": "Získavam šetrič obrazovky",

  // Web Rating New CommonComponents ThankYouModal
  "thank-you-for-contacting-us": "Ďakujeme, že ste nás kontaktovali.",
  "we-ll-be-in-touch-very-soon": "Čoskoro sa s vami spojíme.",

  // Web Rating New CommonComponents GoogleQrPage
  "you-can-follow-this-button-to-rate-us-on-google":
    "Môžete nasledovať toto tlačidlo na ohodnotenie nás na Google",
  "rate-us-on-google": "Ohodnotiť nás na Google",

  // Web Rating New CommonComponents ContactUsModal
  "contact-us": "Kontaktujte nás",
  "or-you-may-reach-us-on": "...alebo nás môžete zastihnúť na.",
  "do-you-want-to-learn-more-about-serve-first":
    "Chcete sa dozvedieť viac o Serve First?",

  // Web Rating New CommonComponents BottomBar
  saving: "Ukladám",
  "please-enter-only-digits-for": "Prosím zadajte len číslice pre",
  "please-enter": "Prosím zadajte",
  "enter-value-here": "Zadajte hodnotu tu",

  // Stránky prieskumu Questions Dropdown
  "please-select": "Prosím vyberte",
  "survey-retry-message":
    "Tento prieskum budete môcť vykonať po {value} {unit}.",
  minute: "minúta",
  minutes: "minúty",
  hour: "hodina",
  hours: "hodiny",
  day: "deň",
  days: "dni",
  week: "týždeň",
  weeks: "týždne",
  month: "mesiac",
  months: "mesiace",
  clear: "Vymazať",

  "powered-by": "Poháňané pomocou",
  "image-is-required": "Obrázok je povinný",
  "please-fill-all-required-contact-information":
    "Prosím vyplňte všetky povinné kontaktné informácie",

  "please-leave-any-extra-feedback-in-the-box-below":
    "Prosím, nechajte akékoľvek ďalšie spätné väzby v poli nižšie.",
  "all-feedback-is-confidential": "Všetky spätné väzby sú konfidenčné",
  "your-feedback-has-been-received-thank-you":
    "Vaša spätná väzba bola prijatá, Ďakujeme",
  "close-page": "Zavrieť stránku",
  send: "Odoslať",
  sending: "Odoslanie",
  "enter-your-feedback-here": "Zadajte vašu spätnú väzbu tu",
  "for-anything-else-please":
    "Na druhej strane, ak je konkrétna téma, ktorú by ste chceli, aby náš tím riešil, neváhajte sa podeliť. Nie som tu len na počúvanie, ale na zapojenie sa a konanie na základe vašich obáv alebo nápadov.",
  "please-correct-the-custom-field-values":
    "Prosím, opravte hodnoty pre vlastné polia",
  "please-complete-all-required-contact-information":
    "Prosím, vyplňte všetky povinné kontaktné informácie",
  "survey-cannot-be-submitted": "Prieskum nemôže byť odoslaný",
  "please-enter-your-phone": "Prosím, zadajte vaše telefónne číslo",
  "network-error-please-try-again":
    "Chyba siete. Skontrolujte pripojenie a skúste to znova.",
  "no-results-found": "Nenašli sa žiadne výsledky",
  "drop-files-here": "Presuňte súbory sem...",
  "drag-drop-files": "Presuňte súbory sem alebo kliknite pre výber súborov",
  "max-5-files-5mb": "Max 5 súborov, 5 MB každý, len obrázky",
  remove: "Odstrániť",

  // Learning & Development

  "ld-module-title": "Vzdelávanie a rozvoj",
  "ld-no-sign-in-required": "Prihlásenie nie je potrebné",
  "ld-progress-warning":
    "Nezatvárajte toto okno — váš postup sa neukladá a museli by ste začať odznova.",
  "ld-loading-module": "Načítava sa vzdelávací modul…",
  "ld-unable-load-module": "Nepodarilo sa načítať vzdelávací modul.",
  "ld-package-not-configured": "Vzdelávací balík nie je nakonfigurovaný.",
  "ld-start-guidance": "Začať školenie",
  "ld-due-date": "Termín {date}",
  "ld-whats-involved": "Čo je zahrnuté",
  "ld-your-progress": "VÁŠ POSTUP",
  "ld-step-of": "Krok {current} z {total}",
  "ld-watched-in-full": "Pozreté celé",
  "ld-video-no-skip": "Môžete pretáčať späť, ale nie dopredu",
  "ld-video-muted-counts": "Stlmené — prehrávanie sa stále započítava",
  "ld-maximize-document": "Maximalizovať dokument",
  "ld-minimize-document": "Minimalizovať dokument",
  "ld-read-percent": "{percent} % prečítané",
  "ld-end-of-document": "Koniec dokumentu",
  "ld-scroll-to-continue": "Posuňte pre pokračovanie",
  "ld-read-to-end": "Prečítané do konca",
  "ld-read-to-end-to-continue": "Prečítajte do konca pre pokračovanie",
  "ld-loading-document": "Načítava sa dokument…",
  "ld-pdf-preview-unavailable":
    "Tento PDF súbor nie je možné zobraziť v prehliadači.",
  "ld-pdf-page-alt": "{title} — strana {page}",
  "ld-knowledge-check": "OVERENIE ZNALOSTÍ",
  "ld-knowledge-check-title": "{title} — overenie znalostí",
  "ld-quiz-instruction":
    "Odpovedzte na {count, plural, one {# otázku} few {# otázky} other {# otázok}}. Hranica úspešnosti {passMark} %.",
  "ld-quiz-instruction-pass-only": "Hranica úspešnosti {passMark} %.",
  "ld-question-of": "OTÁZKA {current} Z {total}",
  "ld-guidance-of": "ŠKOLENIE {current} Z {total}",
  "ld-loading-questionnaire": "Načítava sa dotazník…",
  "ld-preparing-questions": "Pripravujú sa vaše otázky",
  "ld-submit-answers": "Odoslať odpovede",
  "ld-submitting": "Odosiela sa…",
  "ld-ready-to-submit": "Pripravené na odoslanie odpovedí",
  "ld-answer-selected": "Odpoveď vybraná",
  "ld-select-answer": "Vyberte jednu odpoveď pre pokračovanie",
  "ld-pass-mark-note":
    "Na úspešné absolvovanie potrebujete {passMark} % alebo viac. Odpovede po odoslaní nie je možné zmeniť.",
  "ld-questionnaire-not-configured": "Dotazník nie je nakonfigurovaný.",
  "ld-unable-load-questionnaire": "Nepodarilo sa načítať dotazník.",
  "ld-no-visible-questions":
    "Pre túto kontrolu znalostí momentálne nie sú dostupné žiadne otázky.",
  "ld-unable-submit-answers":
    "Nepodarilo sa odoslať odpovede. Skúste to znova.",
  "ld-not-passed": "Neúspešné",
  "ld-completed": "Dokončené",
  "ld-fail-title": "Takmer ste to zvládli — skúste to znova",
  "ld-fail-description":
    "Dosiahli ste {score} — hranica úspešnosti je {passMark} %. Zostáva vám {remaining}.",
  "ld-attempts-remaining":
    "{count, plural, one {# pokus} few {# pokusy} other {# pokusov}}",
  "ld-attempt-of": "Pokus {current} z {total}",
  "ld-fail-alert":
    "Venujte chvíľu opätovnému preštudovaniu sprievodcu a znova absolvujte test. Po poslednom pokuse sa test uzamkne.",
  "ld-try-again": "Skúsiť znova",
  "ld-review-guidance": "Prejsť sprievodcu",
  "ld-locked-title": "Toto školenie je teraz uzamknuté",
  "ld-locked-description":
    "Dosiahli ste {score} — hranica úspešnosti tohto balíka je {passMark} %. Z dôvodu súladu ho tu nemôžete opakovať.",
  "ld-speak-to-manager": "Porozprávajte sa so svojím vedúcim",
  "ld-locked-manager-copy":
    "Váš vedúci služby môže znova priradiť {courseTitle}, aby ste mohli znova prejsť sprievodcu a opakovať test.",
  "ld-close-window": "Teraz môžete zatvoriť toto okno.",
  "ld-close-window-safe": "Teraz môžete bezpečne zatvoriť toto okno.",
  "ld-success-title": "Gratulujeme!",
  "ld-success-description":
    "Úspešne ste dokončili {courseTitle}. Bolo to zaznamenané vo vašom školiacom profile — nemusíte robiť nič ďalšie.",
  "ld-email-yourself": "Poslať kópiu e-mailom",
  "ld-email-copy-description":
    "Pošlite potvrdenie o dokončení do svojej schránky pre vašu evidenciu.",
  "ld-email-placeholder": "vy@firma.sk",
  "ld-sent": "Odoslané",
  "ld-sending-email": "Odosiela sa…",
  "ld-unable-send-email": "E-mail sa nepodarilo odoslať. Skúste to znova.",
  "ld-email-sent-success": "Potvrdzovací e-mail bol úspešne odoslaný!",
  "ld-video-briefing": "Video briefing",
  "ld-document": "Dokument",
  "ld-video-meta": "Video",
  "ld-video-meta-no-skip": "Video · bez preskakovania",
  "ld-document-meta": "Dokument · PDF",
  "ld-document-meta-scroll": "Dokument · PDF · posuňte do konca",
  "ld-video-instruction-full": "Pozrite celé — nemôžete preskakovať dopredu",
  "ld-video-instruction": "Pozrite briefing a potom pokračujte",
  "ld-document-instruction-scroll": "Posuňte do konca pre pokračovanie",
  "ld-document-instruction": "Preštudujte dokument a potom pokračujte",
  "ld-questionnaire": "Dotazník",
  "ld-confirmation": "Potvrdenie",
  "ld-question-count":
    "{count, plural, one {# otázka} few {# otázky} other {# otázok}}",
  "ld-knowledge-check-subtitle": "Overenie znalostí",
  "ld-score": "Skóre",
  "ld-whats-involved-pass-mark":
    "Hranica úspešnosti {passMark} % · odomkne sa po sprievodcovi",
  "ld-document-type-pdf": "{documentType} · PDF",
};
